import { FC, useMemo, useCallback } from 'react'
import * as styles from 'components/features/pfm/TransactionCategory/TransactionCategory.styl'
import { TypedMoneyflowCategory } from 'interfaces/meta'
import cn from 'classnames'
import { ALL_CATEGORY_ID } from 'constants/meta'
import SvgIcon from 'components/atoms/SvgIcon'
import Tooltip from 'components/features/pfm/Tooltip/Tooltip'

type TransactionCategoryProps = {
  category: TypedMoneyflowCategory
  disabled?: boolean
  dim?: boolean
  slim?: boolean // A more minimal design
  onClick?: () => void
  tooltipText?: string
}

export const TransactionCategory: FC<TransactionCategoryProps> = (props) => {
  const {
    category,
    onClick,
    disabled,
    dim,
    slim,
    tooltipText,
  } = props

  const { type, id } = category

  const theme = useMemo(() => {
    if (type === null) {
      return 'gray'
    } else if (type === 'income') {
      return 'green'
    } else {
      return 'blue'
    }
  }, [type])

  const className = useMemo(() => cn(styles.transactionCategory, {
    [styles[theme]]: true,
    [styles.dim]: dim,
    [styles.slim]: slim,
    [styles.withTooltip]: !!tooltipText,
  }), [dim, theme, tooltipText])

  const iconChild = useMemo(() => {
    let iconKind = id
    if (id === ALL_CATEGORY_ID) {
      iconKind = type === 'spending' ? 'spending' : 'income'
    }
    const iconSource = require(`icons/${ iconKind }.svg`).default

    return <SvgIcon src={ iconSource } />
  }, [id, type])

  const handleClick = useCallback(() => {
    onClick && onClick()
  }, [onClick])

  const tooltip = tooltipText && (
    <div className={ styles.tooltipContainer }>
      <Tooltip theme='info'>{ tooltipText }</Tooltip>
    </div>
  )

  return (
    <button className={ className } disabled={ disabled } onClick={ disabled ? () => {} : handleClick }>
      { tooltip }
      <div className={ styles.iconWrapper }>
        <div className={ styles.icon }>
          { iconChild }
        </div>
      </div>
      <div className={ styles.title }>
        { category.value }
      </div>
    </button>
  )
}
